var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container",style:(_vm.styles)},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$variables.brandIcon,"alt":"Otto"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }